import { NgModule } from '@angular/core';
import { LogoutComponent } from './logout.component';
import { NavbarModule } from '@michelin/theme';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [LogoutComponent],
  exports: [LogoutComponent],
  imports: [CommonModule, NavbarModule]
})
export class LogoutModule {}
